import { useState } from "react"
import { useFirestore, useFirestoreCollectionData } from "reactfire"
import { collection, doc, deleteDoc, updateDoc } from "firebase/firestore"
import { LISTA_UNIDADES, UNIDADES } from "../config/unidades"

export default function GestionUsuarios() {
  const firestore = useFirestore()
  const { data: usuarios, status } = useFirestoreCollectionData(
    collection(firestore, "users"), { idField: "id" }
  )

  if (status === "loading") return <div className="loading">Cargando usuarios...</div>

  const admins    = (usuarios || []).filter(u => u.rol === "admin")
  const activos   = (usuarios || []).filter(u => u.rol === "unidad")
  const pendientes = (usuarios || []).filter(u => u.rol === "viewer" || (!u.rol && u.email))

  return (
    <div>

      {/* ── Banner de pendientes ── */}
      {pendientes.length > 0 && (
        <div style={{
          background: "#fffbeb", border: "1px solid #fde68a",
          borderRadius: 12, padding: "16px 20px", marginBottom: 24,
          display: "flex", alignItems: "center", gap: 14,
        }}>
          <div style={{ fontSize: 28 }}>⏳</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: "#92400e", marginBottom: 2 }}>
              {pendientes.length} usuario{pendientes.length > 1 ? "s" : ""} esperando activación
            </div>
            <div style={{ fontSize: 13, color: "#b45309" }}>
              {pendientes.map(u => u.email).join(", ")}
            </div>
          </div>
          <div style={{ fontSize: 12, color: "#92400e", opacity: 0.7 }}>
            Asígnales una unidad en la tabla de abajo ↓
          </div>
        </div>
      )}

      {/* ── Usuarios pendientes ── */}
      {pendientes.length > 0 && (
        <>
          <h3 style={{ fontFamily: "'Playfair Display', serif", color: "#b45309", fontSize: 17, marginBottom: 12 }}>
            ⏳ Pendientes de activación
          </h3>
          <div className="tabla-wrapper" style={{ marginBottom: 28 }}>
            <table>
              <thead>
                <tr>
                  <th>Correo</th>
                  <th>Asignar unidad</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {pendientes.map(u => (
                  <tr key={u.id} style={{ background: "#fffbeb" }}>
                    <td style={{ fontWeight: 600 }}>
                      <span className="badge badge-pendiente" style={{ marginRight: 8 }}>Sin asignar</span>
                      {u.email}
                    </td>
                    <td>
                      <CambiarUnidad usuarioId={u.id} unidadActual={u.unidad} destacado />
                    </td>
                    <td>
                      <EliminarUsuario usuarioId={u.id} firestore={firestore} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ── Usuarios activos ── */}
      <h3 style={{ fontFamily: "'Playfair Display', serif", color: "var(--verde)", fontSize: 17, marginBottom: 12 }}>
        Usuarios activos
      </h3>
      <div className="tabla-wrapper" style={{ marginBottom: 28 }}>
        <table>
          <thead>
            <tr>
              <th>Correo</th>
              <th>Unidad</th>
              <th>Cambiar unidad</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {activos.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ color: "var(--gris)", padding: 32, textAlign: "center" }}>
                  No hay usuarios activos aún.
                </td>
              </tr>
            ) : (
              activos.map(u => {
                const cfg = u.unidad ? UNIDADES[u.unidad] : null
                return (
                  <tr key={u.id}>
                    <td style={{ fontWeight: 500 }}>{u.email}</td>
                    <td>
                      {cfg
                        ? <span className="badge" style={{ background: cfg.bg, color: cfg.texto }}>{cfg.icono} {cfg.nombre}</span>
                        : <span style={{ color: "var(--gris)" }}>—</span>
                      }
                    </td>
                    <td><CambiarUnidad usuarioId={u.id} unidadActual={u.unidad} /></td>
                    <td><EliminarUsuario usuarioId={u.id} firestore={firestore} /></td>
                  </tr>
                )
              })
            )}
          </tbody>
        </table>
      </div>

      {/* ── Admins ── */}
      <h3 style={{ fontFamily: "'Playfair Display', serif", color: "var(--verde)", fontSize: 17, marginBottom: 12 }}>
        Administradores
      </h3>
      <div className="tabla-wrapper">
        <table>
          <thead>
            <tr>
              <th>Correo</th>
              <th>Rol</th>
            </tr>
          </thead>
          <tbody>
            {admins.length === 0 ? (
              <tr><td colSpan={2} style={{ color: "var(--gris)", padding: 20, textAlign: "center" }}>Sin admins registrados</td></tr>
            ) : (
              admins.map(u => (
                <tr key={u.id}>
                  <td style={{ fontWeight: 500 }}>{u.email}</td>
                  <td><span className="badge badge-pagado">Admin</span></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

function CambiarUnidad({ usuarioId, unidadActual, destacado }) {
  const firestore = useFirestore()
  const [guardando, setGuardando] = useState(false)

  const cambiar = async (nuevaUnidad) => {
    setGuardando(true)
    await updateDoc(doc(firestore, "users", usuarioId), {
      unidad: nuevaUnidad || null,
      rol:    nuevaUnidad ? "unidad" : "viewer",
    })
    setGuardando(false)
  }

  return (
    <select
      className="form-select"
      style={{
        width: "auto", padding: "5px 10px", fontSize: 13,
        borderColor: destacado ? "#f59e0b" : undefined,
        fontWeight:  destacado ? 600 : 400,
      }}
      value={unidadActual || ""}
      disabled={guardando}
      onChange={e => cambiar(e.target.value)}
    >
      <option value="">— Sin unidad —</option>
      {LISTA_UNIDADES.map(u => (
        <option key={u.id} value={u.id}>{u.icono} {u.nombre}</option>
      ))}
    </select>
  )
}

function EliminarUsuario({ usuarioId, firestore }) {
  const eliminar = async () => {
    if (!window.confirm("¿Eliminar este usuario de la base de datos?\nEsto no elimina su cuenta de Firebase Auth.")) return
    await deleteDoc(doc(firestore, "users", usuarioId))
  }
  return (
    <button className="btn-icon" title="Eliminar registro" onClick={eliminar}>🗑️</button>
  )
}
